import React from 'react';
import getStyles from './styles';
import { ProjectViewPage } from '../../../components';

const PaarrEverPage = () => {
  const styles = getStyles();
  return (
    <ProjectViewPage
      heroTitle="A Feature-Rich App Built for"
      heroGradientText="Networking and Navigation"
      infoLabel1="Client"
      infoLabel2="Services"
      infoLabel3="Deliverables"
      infoLabel4="Tech Stack"
      client="PAARR ever"
      services={['UX/UI Design', 'Full Stack Development']}
      deliverables={['Mobile Application', 'CMS Dashboard']}
      techStack={['React Native', 'Node.js', 'Express']}
      clientLogo="/images/paar-logo.jpg"
      infoLabel5="Website"
      visitWebsite="Visit Website"
      website="https://paarrever.amizhthstaging.site/"
      overviewTitle="Overview"
      approachTitle="Approach"
      heroImage="/images/paar-first.png"
      overviewImage="/images/paar-first.png"
      approachImage="/images/paar-full.png"
      overviewDescription={[
        'The official mobile app for the Tamil Nadu Global Startup Summit (TNGSS) is your gateway to everything happening at the summit — all in one place.',
        'Designed and developed by Minsky, the app delivers a seamless experience for attendees, investors, startups, and speakers.'
      ]}
      approachDescription={[
        'We took a bold, modern approach — going with a dark theme inspired by the energy of space exploration and rocket launches.',
        'Subtle rocket-inspired elements were integrated across the UI to evoke motion, ambition, and lift-off.',
        'The navigation was kept clean and intuitive, ensuring users could quickly access sessions, speakers, and networking tools without friction.'
      ]}
      heroContainerStyle={styles.container}
      commonSectionStyle={styles.section}
      heroSectionStyle={styles.heroSection}
      heroGradientStyle={styles.heroGradient}
      heroGlow1Style={styles.heroGlow1}
      heroGlow2Style={styles.heroGlow2}
      heroGlow3Style={styles.heroGlow3}
      containerWrapperStyle={styles.containerWrapper}
      heroImageContainerStyle={styles.heroImageContainer}
      phoneContainerStyle={styles.phoneContainer}
      phoneGlowStyle={styles.phoneGlow}
      phoneShadowStyle={styles.phoneShadow}
      heroPhoneStyle={styles.heroPhone}
      heroContentStyle={styles.heroContent}
      heroTitleStyle={styles.heroTitle}
      gradientTextStyle={styles.gradientText}
      infoCardStyle={styles.infoCard}
      infoItemStyle={styles.infoItem}
      infoLabelStyle={styles.infoLabel}
      primaryBadgeStyle={styles.primaryBadge}
      secondaryBadgeStyle={styles.secondaryBadge}
      badgesContainerStyle={styles.badgesContainer}
      accentBadgeStyle={styles.accentBadge}
      outlineBadgeStyle={styles.outlineBadge}
      overviewSectionStyle={styles.overviewSection}
      overviewGradientStyle={styles.overviewGradient}
      overviewGlowStyle={styles.overviewGlow}
      overviewGridStyle={styles.overviewGrid}
      overviewContentStyle={styles.overviewContent}
      sectionHeaderStyle={styles.sectionHeader}
      accentLineStyle={styles.accentLine}
      sectionTitleStyle={styles.sectionTitle}
      textContainerStyle={styles.textContainer}
      sectionTextStyle={styles.sectionText}
      overviewImageContainerStyle={styles.overviewImageContainer}
      overviewImageWrapperStyle={styles.overviewImageWrapper}
      overviewImageGlowStyle={styles.overviewImageGlow}
      overviewImageStyle={styles.overviewImage}
      approachSectionStyle={styles.approachSection}
      approachGradientStyle={styles.approachGradient}
      approachGlow1Style={styles.approachGlow1}
      approachGlow2Style={styles.approachGlow2}
      approachGridStyle={styles.approachGrid}
      approachContentStyle={styles.approachContent}
      approachAccentLineStyle={styles.approachAccentLine}
      approachTitleStyle={styles.approachTitle}
      approachTextStyle={styles.approachText}
      scrollAreaStyle={styles.scrollArea}
      scrollContentStyle={styles.scrollContent}
      approachImageWrapperStyle={styles.approachImageWrapper}
      approachImageGlowStyle={styles.approachImageGlow}
      approachImageStyle={styles.approachImage}
    />
  );
};

export default PaarrEverPage;
